// Reduces a full stored name to "first word + last word".
// Used at every user-facing display site so that "John Michael Smith Doe"
// renders as "John Doe". The full name continues to be stored verbatim;
// this transform happens at render time only.
//
// Examples:
//   "John Michael Smith Doe" -> "John Doe"
//   "John Doe"               -> "John Doe"
//   "John"                   -> "John"
//   "  John   Doe  "         -> "John Doe"
//   "" / null / undefined    -> ""
export function getDisplayName(fullName) {
  if (fullName === null || fullName === undefined || fullName === '') return '';
  const parts = String(fullName).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1]}`;
}

// Avatar-fallback initials derived from the shortened name.
// "John Michael Smith Doe" -> "JD"  (not "JMSD")
// "John"                   -> "J"
// "" / null                -> "?"
export function getDisplayInitials(fullName) {
  const display = getDisplayName(fullName);
  if (!display) return '?';
  return display
    .split(/\s+/)
    .map((p) => p[0] || '')
    .join('')
    .toUpperCase();
}
